import { duviNicheSiteBuildRegisterUrl } from "@/config";
import type {
  DuviNicheSiteHomeFeature,
  DuviNicheSiteHomeModel,
} from "./duvi-niche-site-home.types";

/**
 * Feature copy, drawn from the bespoke Fishwalkers brochure prototype's
 * feature grid (duvi-design/exports/niches/fishwalkers/brochure.zip) and
 * written in the design system's committed voice: the walker is the subject,
 * sentence case throughout, and the niche's own vocabulary — walkers, fish
 * owners, walks, rounds. Fishwalkers is a service that walks people's pet
 * fish; nothing here reads as angling, and it must not drift back that way.
 *
 * Content data, not markup — the view maps each `icon` to its glyph.
 */
const FEATURES: DuviNicheSiteHomeFeature[] = [
  {
    icon: "house",
    title: "Your own page",
    body: "Built from your details — no design or setup work needed.",
  },
  {
    icon: "footprints",
    title: "Show your walks",
    body: "Your walk lengths, prices and photos, ready for owners to browse and book.",
  },
  {
    icon: "map-pin",
    title: "Set your round",
    body: "Choose the postcodes and streets you cover, so nearby owners find you.",
  },
];

/**
 * useDuviNicheSiteHome — Home screen behaviour: derives the sign-up hand-off
 * URL from build-time config and exposes the feature content. No JSX or DOM
 * wiring lives here, so a redraw from a future export touches only the view.
 */
export function useDuviNicheSiteHome(): DuviNicheSiteHomeModel {
  return {
    registerUrl: duviNicheSiteBuildRegisterUrl(),
    features: FEATURES,
  };
}
